<template>
  <el-dialog
    :close-on-click-modal="false"
    title="查看流程"
    :visible.sync="showDialog"
    width="560px"
    class="mini-dialog"
    append-to-body
    v-dialogDrag
  >
    <div>
      <el-steps
        :active="active"
        direction="vertical"
        finish-status="success"
        process-status="process"
      >
        <el-step title="危险源辨识计划">
          <template slot="description">
            <div>
              <span class="mr-10px">{{ formData.planHeadControlName }}</span
              >{{ formData.planPublishTime | format }}
            </div>
          </template>
        </el-step>
        <el-step title="危险源辨识">
          <template slot="description">
            <div>
              <span class="mr-10px">{{ formData.riskRecognitionEvaluationLeaderName }}</span
              >{{ formData.recognitionTime | format }}
            </div>
          </template>
        </el-step>
        <el-step title="危险评估">
          <template slot="description">
            <div>
              <span class="mr-10px">{{ formData.riskRecognitionEvaluationLeaderName }}</span
              >{{ formData.riskAssessTime | format }}
            </div>
          </template>
        </el-step>
        <el-step title="管控审核">
          <template slot="description">
            <div>
              <span class="mr-10px">{{ formData.planHeadControlName }}</span
              >{{ formData.riskControlTime | format }}
            </div>
            <div class="font-bold" v-if="formData.overruleReasons">
              驳回原因：{{ formData.overruleReasons }}
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <div slot="footer" class="text-center" v-if="false">
      <el-button type="primary" size="small" @click="handleOk()" icon="iconfont icon-save">
        <span>确定</span>
      </el-button>
      <el-button size="small" @click="showDialog = false" icon="iconfont icon-close">
        <span>取消</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SourcesDangerRecognitionPlanTaskApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'

const sourcesDangerRecognitionPlanTaskApi = new SourcesDangerRecognitionPlanTaskApi()

export default {
  name: 'flow-details',
  props: {
    taskId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      formData: {},
      active: 0,
      showDialog: false,
    }
  },
  filters: {
    format(value) {
      if (!value) return ''
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  watch: {
    taskId: {
      immediate: true,
      handler(taskId) {
        this.getData()
      },
    },
  },
  computed: {},
  methods: {
    handleOk() {
      this.$emit('change', this.selectionData)
      this.showDialog = false
    },
    async getData() {
      if (!this.taskId) {
        this.formData = {}
        return
      }
      const [
        err,
        res,
      ] = await sourcesDangerRecognitionPlanTaskApi.sourcesDangerRecognitionPlanTaskProgress({
        planTaskId: this.taskId,
      })
      if (!err) {
        this.formData = res
        this.active = res.status
      }
    },
  },
  created() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-step__line {
  background-color: #c0c4cc !important;
}
</style>
